<template>
  <div class="ksm-flex-1 ksm-flex-column" style="background-color:#eee">
    <div class="ksm-flex-1 ksm-flex">
      <div class="ksm-ursonate_note-wrapper">
        <div class="ksm-flex-1 ksm-flex-column" style="position:relative">
          <div style="position:absolute; height:100%; width:100%" class="ksm-flex-column">
            <div class="ksm-flex-1" style="position:relative">
              <div class="ksm-ursonate_note"></div>
            </div>
            <div class="ksm-flex-00auto ksm-flex">
              <div class="ksm-flex-1" style="position:relative">
                <PlayerControls
                  v-if="midiData"
                  @seekbarChange="seekbarChange"
                  @playPause="playPause"
                  :duration="duration"
                  :currentTime="currentTime"
                  :media="midiData"
                  :mediaType="'midi'"
                  :mediaName="meiName"
                ></PlayerControls>
                <div class="ksm-flex-y-center" style="position:absolute;height:100%; width:100%">
                  <div class="ksm-ursonate_player" style="height:0px;overflow:hidden;width:0px"></div>
                  <!-- <div class="ksm-ursonate_player"></div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import PlayerControls from "./PlayerControls";
import { MIDI } from "../../../vendor/midi.js";

// MIDI.loadPlugin({
//   soundfontUrl: "./static/soundfont/",
//   instrument: "acoustic_grand_piano", // or the instrument code 1 (aka the default)
//   onsuccess: function() {}
// });
const midiPlayer = MIDI.Player;

export default {
  props: ["meiName", "seite"],
  components: { PlayerControls },
  data() {
    return {
      currentTime: 0,
      duration: 0,
      midiData: null,
      noteTranscriptMap: null,
      transcriptMeasureMap: null,
      meiTranscripts: [],
      page: 1,
      ids: [],
      zoom: 20,
      svg: null,
      playerDataLoaded: false
    };
  },
  watch: {
    meiName() {
      this.svgHighligthReset();
      midiPlayer.stop();
      this.playerDataLoaded = false;
      this.loadMei();
    },
    midiData(d) {
      this.svgHighligthReset();
      midiPlayer.stop();
    }
  },
  mounted() {
    this.initPlayer();
    this.loadMei();
  },

  methods: {
    initPlayer() {
      const vue = this;
      const vrvToolkit = new verovio.toolkit();
      this.vrvToolkit = vrvToolkit;
      window.addEventListener("resize", function() {
        // if (vue.$route.name.indexOf("ursonate") < 0) {
        //   return;
        // }
        // vue.applyZoom();
      });

      const { w, h } = this.getContainerSize();
      midiPlayer.setAnimation(function(data, element) {
        vue.currentTime = midiPlayer.currentTime;
      });
      midiPlayer.addListener(function(data) {
        vue.midiUpdate(data.now);
      });
    },

    seekbarChange(t) {
      if (midiPlayer.playing) {
        midiPlayer.pause();
        midiPlayer.currentTime = t;
        midiPlayer.resume();
      } else {
        midiPlayer.currentTime = t;
        this.midiUpdate(t);
      }
    },

    playPause(pause) {
      if (pause) {
        midiPlayer.pause(true);
        return;
      }
      const vue = this;
      if (!this.playerDataLoaded) {
        this.playerDataLoaded = true;
        midiPlayer.loadFile(this.midiData, function() {
          midiPlayer.start();
          vue.duration = midiPlayer.endTime;
          vue.currentTime = midiPlayer.currentTime;
        });
      } else {
        midiPlayer.resume();
      }
    },
    getContainerSize() {
      const container = this.$el.querySelector(".ksm-ursonate_note");
      const style = window.getComputedStyle(container);
      return {
        w: parseFloat(style.getPropertyValue("width").replace("px", "")),
        h: parseFloat(style.getPropertyValue("height").replace("px", ""))
      };
    },

    setOptions() {
      const vue = this;
      const zoom = this.zoom;
      const { w, h } = this.getContainerSize();
      const pageHeight = (h * 100) / zoom;
      const pageWidth = (w * 100) / zoom;
      const options = {
        // pageHeight: pageHeight,
        // pageWidth: pageWidth,
        scale: zoom,
        adjustPageHeight: true
      };
      this.vrvToolkit.setOptions(options);
    },

    sondernFall(file, data) {
      console.log(file);
      // if (file.indexOf("que_06842365_ von hinten_Cvin, Bl.1r") > -1) {
      //   data = data.replace(
      //     /<scoreDef[^>]*>([\s\S]*?)<\/scoreDef>/gi,
      //     '<scoreDef xml:id="m-26"><staffGrp xml:id="m-27"><staffDef xml:id="m-28" clef.line="2" clef.shape="G" lines="5" n="1"></staffDef></staffGrp></scoreDef>'
      //   );
      // }
      if (file.indexOf("que_06842367_Bl.3v, Bl.4r.mei") > -1) {
        data = data.replace(
          '<staff xml:id="m-303" n="1">',
          '<measure xml:id="m-302" n="14" facs="#zone_1fae54ca-f00e-40f3-b45e-715cca533a9d"><staff xml:id="m-303" n="1">'
        );
      }

      // const arr = [
      //   "que_06842363_Bl.2v, Bl.3r",
      //   "que_06842363_Bl.1v, Bl.2r",
      //   "que_06842365_ von hinten_Cvin, Bl.1r",
      //   "que_06842367_Bl.2v, Bl.3r",
      //   "que_06842367_Bl.3v, Bl.4r",
      //   "que_06842371.mei",
      //   "que_06842373_r",
      //   "que_06842373_v",
      //   "que_06842374",
      //   "que_06842375.mei",
      //   "que_06842377_r.mei",
      //   "que_06842377_v.mei"
      // ];
      // const mergeMdivs = arr.find(f => file.indexOf(f) > -1);
      const xmlData = $.parseXML(data);
      const mdivs = xmlData.querySelectorAll("mdiv");
      if (mdivs.length > 1) {
        const section1 = mdivs[0].querySelector("section");
        let i = 0;
        for (const d of mdivs) {
          if (i > 0) {
            const measures = d.querySelectorAll("measure");
            for (const m of measures) {
              section1.appendChild(m);
            }
            d.remove();
          }
          i++;
        }

        let xmlString;
        //IE
        if (window.ActiveXObject) {
          xmlString = xmlData.xml;
        }
        // code for Mozilla, Firefox, Opera, etc.
        else {
          xmlString = new XMLSerializer().serializeToString(xmlData);
        }
        data = xmlString;
      }

      return data;
    },

    midiUpdate(time) {
      if (time === midiPlayer.endTime) {
      }
      const vue = this;
      // time needs to - 400 for adjustment
      const vrvTime = Math.max(0, time);
      let ids = this.ids;
      const elementsattime = this.vrvToolkit.getElementsAtTime(vrvTime);
      if (elementsattime.page > 0) {
        if (elementsattime.page != this.page) {
          this.page = elementsattime.page;
          this.loadPage();
        }

        if (
          elementsattime.notes.length > 0 &&
          this.ids != elementsattime.notes
        ) {
          this.ids.forEach(function(noteid) {
            if ($.inArray(noteid, elementsattime.notes) == -1) {
              const transcript = vue.noteTranscriptMap.get(noteid);
              const measure = vue.transcriptMeasureMap.get(transcript);
              if (measure) {
                const measurElem = vue.container.querySelector(
                  "#rect_" + measure
                );
                if (measurElem) {
                  measurElem.classList.remove("ksm-ursonate_measure-active");
                }
              }

              const noteElem = vue.container.querySelector("#" + noteid);
              if (noteElem) {
                noteElem.classList.remove("ksm-ursonate_note-active");
              }
            }
          });
          this.ids = elementsattime.notes;
          this.ids.forEach(function(noteid) {
            if ($.inArray(noteid, elementsattime.notes) != -1) {
              //notify
              const tr_id = vue.noteTranscriptMap.get(noteid);
              vue.$emit("transcriptUpdate", [tr_id]);

              const transcript = vue.noteTranscriptMap.get(noteid);
              const measure = vue.transcriptMeasureMap.get(transcript);
              if (measure) {
                const n1 = vue.container.querySelector("#rect_" + measure);
                if (n1) {
                  n1.classList.add("ksm-ursonate_measure-active");
                }
              }
              const n2 = vue.container.querySelector("#" + noteid);
              if (n2) {
                n2.classList.add("ksm-ursonate_note-active");
              }
            }
          });
        }
      }
    },
    svgHighligthReset() {
      const vue = this;
      this.ids.forEach(function(noteid) {
        const transcript = vue.noteTranscriptMap.get(noteid);
        const measure = vue.transcriptMeasureMap.get(transcript);
        if (measure) {
          const n1 = vue.container.querySelector("#rect_" + measure);
          if (n1) {
            n1.classList.remove("ksm-ursonate_measure-active");
          }
        }
        const n2 = vue.container.querySelector("#" + noteid);
        if (n2) {
          n2.classList.remove("ksm-ursonate_note-active");
        }
      });
      vue.$emit("transcriptUpdate", []);
    },

    applyZoom() {
      this.vrvToolkit.redoLayout();
      this.setOptions();
      this.loadPage();
    },

    parseMei(file, data) {
      this.setOptions();
      data = this.sondernFall(file, data);

      let tmpDiv = document.createElement("div");
      const tmpTrs = [];
      tmpDiv.innerHTML = data;

      const surface = tmpDiv.querySelectorAll("surface");
      for (const sf of surface) {
        const zones = sf.querySelectorAll("zone");
        for (const zone of zones) {
          const id = zone.getAttribute("xml:id");
          const ulx = zone.getAttribute("ulx");
          const uly = zone.getAttribute("uly");
          const lrx = zone.getAttribute("lrx");
          const lry = zone.getAttribute("lry");
          tmpTrs.push({
            id: id.replace("zone_", ""),
            x: parseFloat(ulx),
            y: parseFloat(uly),
            w: parseFloat(lrx) - parseFloat(ulx),
            h: parseFloat(lry) - parseFloat(uly)
          });
        }
      }
      this.meiTranscripts = tmpTrs;
      this.seite.$_allTranscripts[0] = {
        transcripts: tmpTrs
      };
      this.seite.$_parseMei = true;
      const noteMap = new Map();
      const measureMap = new Map();
      const measure = tmpDiv.querySelectorAll("measure");
      for (const m of measure) {
        const facs = m.getAttribute("facs");
        if (!facs) {
          continue;
        }
        const tr_id = facs.replace("#zone_", "");
        measureMap.set(tr_id, m.getAttribute("xml:id"));
        const notes = m.querySelectorAll("note");
        for (const n of notes) {
          const xmlId = n.getAttribute("xml:id");
          if (xmlId) {
            noteMap.set(xmlId, tr_id);
          }
        }
      }
      this.noteTranscriptMap = noteMap;
      this.transcriptMeasureMap = measureMap;

      this.vrvToolkit.loadData(data);
      const base64midi = this.vrvToolkit.renderToMIDI();
      this.midiData = "data:audio/midi;base64," + base64midi;
      this.page = 1;
      this.loadPage();
    },

    loadMei() {
      const vue = this;
      // vue.midiData = null;
      if (!this.meiName) {
        return;
      }

      if (this.container) {
        this.container.innerHTML = "";
      }
      let meiName = this.meiName;
      if (meiName === "que_06842362_von hinten_Cvin, Bl.1r.mei") {
        meiName = "que_06842362_Bl.3v, Cvin.mei";
      } else if (meiName === "que_06842362_von hinten_Bl.1v, Bl.2r.mei") {
        meiName = "que_06842362_Bl.2v, Bl.3r.mei";
      } else if (meiName === "que_06842366_Bl.1v, Bl.2r.mei") {
        meiName = "que_06842366_ Bl.1v, Bl.2r.mei";
      }
      const file = "./static/multimedia/mei/" + meiName;
      $.ajax({
        url: file,
        dataType: "text",
        success: function(data) {
          vue.parseMei(file, data);
        },
        error: function() {
          vue.midiData = null;
          vue.seite.$_parseMei = true;
          console.log(file, "nicht gefunden!!!");
        }
      });
    },

    loadPage() {
      const vrvToolkit = this.vrvToolkit;
      const page = this.page ? this.page : 1;
      const svg = vrvToolkit.renderToSVG(page, {});
      const container = this.$el.querySelector(".ksm-ursonate_note");
      container.innerHTML = svg;
      this.container = container;
      let measureGs = container.querySelectorAll(".measure");
      for (const g of measureGs) {
        const box = g.getBBox();
        d3.select(g)
          .append("rect")
          .attr("x", box.x)
          .attr("y", box.y)
          .attr("id", "rect_" + g.getAttribute("id"))
          .attr("width", box.width)
          .attr("height", box.height)
          .attr("fill", "transparent");
      }

      //rect 挡住了
      // $(".note").click(function() {
      //   const id = $(this).attr("id");
      //   const time = vrvToolkit.getTimeForElement(id);
      //   midiPlayer.currentTime=time;
      //   console.log(time)
      // });
    }
  }
};
</script>

<style lang="scss" >
.ksm-ursonate_note-wrapper {
  flex: 1;
  padding: 10px 10px 0px 10px;
  @extend .ksm-flex;
}
.ksm-ursonate_note {
  position: absolute;
  height: 100%;
  width: 100%;
  svg {
    height: 100%;
    width: 100%;
  }
}

.ksm-ursonate__thumbnail--wrapper {
  @extend .ksm-flex-1;
  position: relative;
  padding: 0px 20px;
}
.ksm-ursonate__thumbnail {
  height: 100%;
  width: 100%;
  @extend .ksm-flex;
}

.ksm-ursonate_measure-active {
  fill: rgba(223, 126, 126, 0.336);
}

.ksm-ursonate_player {
  @extend .ksm-flex-1;
}

.ksm-ursonate_note-active {
  fill: #c00;
  stroke: "#c00";
}
</style>


// WEBPACK FOOTER //
// NotenPlayer.vue?ea705308